import { graphql } from 'gql';

export const globalOtherCostsGql = graphql(`
    query globalOtherCosts(
        $methodology: ProjectMethodologyEnum!
        $skip: Int
        $take: Int
        $order: [GlobalOtherCostDataSortInput!]
        $where: GlobalOtherCostDataFilterInput
    ) {
        globalOtherCosts(methodology: $methodology, skip: $skip, take: $take, order: $order, where: $where) {
            items {
                id
                name
                methodology
                section
                chapter
                calculatingType
                formula
                otherCostType {
                    id
                    uniqueId
                    name
                }
            }
            totalCount
        }
    }
`);

export const globalLimitedCostsGql = graphql(`
    query globalLimitedCosts(
        $methodology: ProjectMethodologyEnum!
        $skip: Int
        $take: Int
        $order: [GlobalLimitedCostDataSortInput!]
        $where: GlobalLimitedCostDataFilterInput
    ) {
        globalLimitedCosts(methodology: $methodology, skip: $skip, take: $take, order: $order, where: $where) {
            items {
                id
                name
                methodology
                chapter
                section
                formula
                catalogLimitedCostType {
                    id
                    uniqueId
                    name
                }
            }
            totalCount
        }
    }
`);

export const globalOtherCostCandidateTypesGql = graphql(`
    query globalOtherCostCandidateTypes($methodology: ProjectMethodologyEnum!, $excludeGlobalOtherCostId: Long) {
        globalOtherCostCandidateTypes(methodology: $methodology, excludeGlobalOtherCostId: $excludeGlobalOtherCostId) {
            id
            uniqueId
            name
            isSystem
        }
    }
`);

export const globalLimitedCostCandidateTypesGql = graphql(`
    query globalLimitedCostCandidateTypes($methodology: ProjectMethodologyEnum!, $excludeGlobalLimitedCostId: Long) {
        globalLimitedCostCandidateTypes(
            methodology: $methodology
            excludeGlobalLimitedCostId: $excludeGlobalLimitedCostId
        ) {
            id
            uniqueId
            name
            isSystem
        }
    }
`);

export const isUniqueGlobalOtherCostGql = graphql(`
    query isUniqueGlobalOtherCost(
        $id: Long
        $name: String!
        $section: SectionEnum!
        $methodology: ProjectMethodologyEnum!
        $calculatingType: OtherCostCalculationTypeEnum!
    ) {
        isUniqueGlobalOtherCost(
            id: $id
            name: $name
            section: $section
            methodology: $methodology
            calculatingType: $calculatingType
        ) {
            result
        }
    }
`);

export const isUniqueGlobalLimitedCostGql = graphql(`
    query isUniqueGlobalLimitedCost($id: Long, $name: String!, $methodology: ProjectMethodologyEnum!) {
        isUniqueGlobalLimitedCost(id: $id, name: $name, methodology: $methodology) {
            result
        }
    }
`);

export const createGlobalOtherCostGql = graphql(`
    mutation createGlobalOtherCost($input: GlobalOtherCostCreateInput!) {
        createGlobalOtherCost(input: $input) {
            result
            message
            validation {
                property
                message
            }
            data {
                id
            }
        }
    }
`);

export const updateGlobalOtherCostGql = graphql(`
    mutation updateGlobalOtherCost($input: GlobalOtherCostUpdateInput!) {
        updateGlobalOtherCost(input: $input) {
            result
            message
            validation {
                property
                message
            }
            data {
                id
            }
        }
    }
`);

export const removeGlobalOtherCostGql = graphql(`
    mutation removeGlobalOtherCost($id: Long!) {
        removeGlobalOtherCost(id: $id) {
            result
            id
            message
        }
    }
`);

export const createGlobalLimitedCostGql = graphql(`
    mutation createGlobalLimitedCost($input: GlobalLimitedCostCreateInput!) {
        createGlobalLimitedCost(input: $input) {
            result
            message
            validation {
                property
                message
            }
            data {
                id
            }
        }
    }
`);

export const updateGlobalLimitedCostGql = graphql(`
    mutation updateGlobalLimitedCost($input: GlobalLimitedCostUpdateInput!) {
        updateGlobalLimitedCost(input: $input) {
            result
            message
            validation {
                property
                message
            }
            data {
                id
            }
        }
    }
`);

export const removeGlobalLimitedCostGql = graphql(`
    mutation removeGlobalLimitedCost($id: Long!) {
        removeGlobalLimitedCost(id: $id) {
            result
            id
            message
        }
    }
`);
